import * as Types from '../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { DestinationFragmentDoc } from './destination';
export type ActionFragment = {
  __typename: 'Action';
  serverAction: { __typename: 'ServerAction'; payload: string } | null;
  tracking: {
    __typename: 'Tracking';
    identifier: string;
    details: Types.Scalars['Map']['output'];
  } | null;
  clientAction:
    | {
        __typename: 'DestinationClientAction';
        destination: {
          __typename: 'Destination';
          icid: Types.Scalars['Map']['output'] | null;
          externalId: string;
          path: string;
          type: Types.DestinationType;
        };
      }
    | { __typename: 'DisplayCastMenuAction'; actionName: string }
    | { __typename: 'DisplayPageModalAction'; path: string }
    | { __typename: 'IgnoreClientAction'; actionName: string }
    | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
    | { __typename: 'OpenNotificationSettingsClientAction' }
    | { __typename: 'OpenPrivacySettingsClientAction' }
    | { __typename: 'OpenTechnicalInformationClientAction' }
    | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
    | { __typename: 'ReloadClientAction'; actionName: string }
    | { __typename: 'ShowActionsModalClientAction'; actionName: string }
    | { __typename: 'SignOutClientAction' }
    | {
        __typename: 'ToggleButtonAction';
        actionName: string;
        reloadDelayInMs: number | null;
        shouldReloadClient: boolean;
      };
};

export type DoServerActionMutationVariables = Types.Exact<{
  payload: Types.Scalars['String']['input'];
}>;

export type DoServerActionMutation = { action: boolean };

export const ActionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Action' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverAction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ServerAction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'payload' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientAction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'DestinationClientAction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'destination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'DestinationFragment' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'icid' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OpenEntitlementClientAction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'primaryId' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IgnoreClientAction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'actionName' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReloadClientAction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'actionName' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'DisplayCastMenuAction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'actionName' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'DisplayPageModalAction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'path' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ToggleButtonAction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reloadDelayInMs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shouldReloadClient' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PartnerLinkClientAction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShowActionsModalClientAction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'actionName' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionFragment, unknown>;
export const DoServerActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DoServerAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payload' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DoServerActionMutation, DoServerActionMutationVariables>;
